export class automationapidata {
  connectorName: string;
  description: string;
  status: string;
  authType: string;
  label_nm: string;
  key_nm: string;
  testURL: string;

}
